export default function isEmpty(data) {
  return [Object, Array].includes((data || {}).constructor) && !Object.entries(data || {}).length;
}
